import { transactionTypes } from "../../../shared/utilities/Constants";
import { RelatedCustomer } from "../internal-transfer/RelatedCustomer";
import { Intermediary, MailingDetails } from "./Intermediary";
import { TaxRemittance } from "./WireInfo";
import { IraTransactionRequest, SloaId } from "./WireSubmitRequest";

export class BaseDraft {
    groupId?: string;
    draftId: string = '';
    masterAccount: string = '';
    subAccount: string = '';
    transactionStatus: string = 'template';
    transactionType: string = transactionTypes.wire;
    transactionAmount: number = 0;
    transactionProcessDate: string = '';
    createDate: string = '';
    lastEditedDate: string = '';
    closedDate: string = '';
    lastEditedLoginId: string = '';
    createdByLoginId: string;
    validationStatus: ValidationStatusType = 'Validating';
    validationResults: ValidationResults[] = [
        {
            isValid: false,
            validator: '',
            errorMessage: ''
        }
    ];
    isMoveMoneyAuthorized?: boolean;
}

export class WireTemplatesRequest extends BaseDraft {
    draftObject: DraftsCommonModelsWireDraft;

    public constructor(init?: Partial<WireTemplatesRequest>) {
        super();
        Object.assign(this, init);
    }
}

export class WireDraftEditableFields {
    processDate?: string = '';
    frequency: string = '';
    amount: number = 0;
    isThirdParty: boolean = false;
    isFirstPartyModified: boolean;
    isEscrow: boolean = false;
    beneficiaryBankId: string = '';
    beneficiaryAccount: string = '';
    beneficiary: MailingDetails = {
        namePartOne: '',
        namePartTwo: '',
        addressLineOne: '',
        addressLineTwo: '',
        phoneNumber: '',
        countryCode: '',
        countryName: ''
    };
    beneficiaryBank: MailingDetails = {
        namePartOne: '',
        namePartTwo: '',
        addressLineOne: '',
        addressLineTwo: '',
        phoneNumber: '',
        countryCode: '',
        countryName: ''
    };
    note: string = '';
    nickname: string = '';
    intermediary: Intermediary = {
        id: '',
        mailingDetails: {
            namePartOne: '',
            namePartTwo: '',
            addressLineOne: '',
            addressLineTwo: '',
            phoneNumber: '',
            countryCode: '',
            countryName: ''
        }
    };
    creditTo: Intermediary = {
        id: '',
        mailingDetails: {
            namePartOne: '',
            namePartTwo: '',
            addressLineOne: '',
            addressLineTwo: '',
            phoneNumber: '',
            countryCode: '',
            countryName: ''
        }
    };
    iraTransactionRequest: IraTransactionRequest = {
        distributionReason: {
            code: '',
            subCode: '',
            description: ''
        },
        fedTaxPercentage: 0,
        stateTaxPercentage: 0,
        isWithholdFedTax: false,
        isWithholdStateTax: false,
        isGrossAmt: false
    };
    isProcessDateExtended: boolean = false;
    confirmationId: string = '';
    isUsingEauth: boolean = false;
}

export class DraftsCommonModelsWireDraft extends WireDraftEditableFields {
    masterAccountId: string = '';
    subAccountId: string = '';
    transactionEAuthClient: RelatedCustomer = {
        isAccountWebEnabled: false,
        customerId: '',
        isCustomerWebEnrolled: false,
        emailId: '',
        firstName: '',
        lastName: '',
        loginIdEnrollStatus: '',
        isDisplayAllowed: false,
        isCustomerEAuthEligible: false,
        organizationName: '',
        eauthInd: false,
        typeCode: '',
        customerRestrictionReason: '',
        accountRoles: []
    };
    clientAttested: boolean = true;
    bsloaTransaction: boolean = false;
    sloaId: SloaId =  {
        cashieringRequestId: '',
        cashieringRequestSecondId: ''
    };
    isUseSloa: boolean = false;
    initiatedBy: string = '';
    isCreateSloa: boolean = false;
    isSubmitAndCreateSloa: boolean;
    draftId: string = '';
    originalRequestedDate: string = '';
    acknowledgementConsentDateTime: string = '';
    isIrsAba: boolean = false;
    taxRemittance?: TaxRemittance = undefined;

    public constructor(init?: Partial<DraftsCommonModelsWireDraft>) {
        super();
        Object.assign(this, init);
    }
}

export enum ValidationStatus {
    Created,
    Validating,
    Failed,
    Validated,
    Revalidating
}

export type ValidationStatusType = keyof typeof ValidationStatus;

export interface ValidationResults {
    isValid: boolean;
    validator: string;
    errorMessage: string;
}